/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {Component, Input, Output, ChangeDetectionStrategy} from '@angular/core';
import {PartNumberChangesDetailFooterActionsEnum} from '../models/part-number-changes-detail-footer-actions.enum';
import {PartNumberChangesDetailFooterConfigurationModel} from '../services/part-number-changes-detail-configuration/models/part-number-changes-detail-footer-configuration.model';
import {Subject} from 'rxjs';

@Component({
    selector: 'app-part-number-changes-detail-footer',
    templateUrl: './part-number-changes-detail-footer.component.html',
    styleUrls: ['./part-number-changes-detail-footer.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PartNumberChangesDetailFooterComponent {

    @Output() action: Subject<PartNumberChangesDetailFooterActionsEnum> = new Subject<PartNumberChangesDetailFooterActionsEnum>();

    @Input() configuration: PartNumberChangesDetailFooterConfigurationModel = <PartNumberChangesDetailFooterConfigurationModel>{};

    footerClick(action: PartNumberChangesDetailFooterActionsEnum): void {
        this.action.next(action);
    }

}
